/**
 * Meter-model helpers shared between AdminLoadIn cells and ServiceTile.
 *
 * Previously duplicated in two places; consolidated here as the single
 * canonical copy (2026-05-27).
 */

// Map Telegraf measurement names to operator-facing model labels. Unknown
// models fall through to the raw name so an unrecognized meter still shows
// _something_ rather than blank.
export function meterModelLabel(model: string | null | undefined): string | null {
  if (!model) return null;
  if (model === "acuvim3") return "Acuvim 3";
  // Edge telegraf tag is "acuvim2r" (no underscore); some older paths
  // use the underscored form "acuvim_2r". Accept both.
  if (model === "acuvim_2r" || model === "acuvim2r") return "Acuvim II-R";
  return model;
}

// True for Acuvim II-R meters (which have no datapost subsystem).
export function isIir(model: string | null | undefined): boolean {
  return model === "acuvim_2r" || model === "acuvim2r";
}
